/**
 * 月次サマリー一覧ページ専用i18n定数
 */

export const MONTHLY_SUMMARIES_LIST_I18N = {
  // ステータス
  status: {
    active: $localize`:@@systemAdmin.monthlySummariesList.status.active:有効`,
    inactive: $localize`:@@systemAdmin.monthlySummariesList.status.inactive:無効`,
    fixed: $localize`:@@systemAdmin.monthlySummariesList.status.fixed:確定`,
    unfixed: $localize`:@@systemAdmin.monthlySummariesList.status.unfixed:未確定`,
    exceeded: $localize`:@@systemAdmin.monthlySummariesList.status.exceeded:超過`,
    noData: $localize`:@@systemAdmin.monthlySummariesList.status.noData:データなし`,
    loading: $localize`:@@systemAdmin.monthlySummariesList.status.loading:読み込み中`,
  },

  // サブページタイトル
  subpageTitle: {
    systemAdmin: $localize`:@@systemAdmin.monthlySummariesList.subpageTitle.systemAdmin:システム管理`,
    sectionGroupAdmin: $localize`:@@systemAdmin.monthlySummariesList.subpageTitle.sectionGroupAdmin:セクショングループ管理`,
    sectionAdmin: $localize`:@@systemAdmin.monthlySummariesList.subpageTitle.sectionAdmin:セクション管理`,
  },
} as const;

export type MonthlySummariesListI18n = typeof MONTHLY_SUMMARIES_LIST_I18N;
